{
  "R": [3, 112, 144, 188, 236, 246, 255],
  "G": [5, 31, 29, 22, 76, 158, 250],
  "B": [26, 87, 91, 86, 62, 117, 235],
  "A": [0, 30, 38, 49, 67, 85, 107],
  "I": [0, 73, 92, 118, 160, 205, 255]
}
